<section>
  <table class="w-95 detail-table">
    <thead>
      @for (header of subHead; track header.Label) {
        <th>
          {{ header.Label }}
        </th>
      }
    </thead>
    <tbody>
      @for (product of products; track product.productName) {
        <tr>
          @for (header of subHead; track header.DataField) {
            <td>
              @if (header.DataField.toLowerCase() === 'scoreclass') {
                @if (
                  product.scoreClass &&
                  product.scoreClass.toLowerCase() === 'positive'
                ) {
                  <mat-icon class="positive">check_circle</mat-icon>
                }
                @if (
                  product.scoreClass &&
                  product.scoreClass.toLowerCase() === 'neutral'
                ) {
                  <mat-icon class="neutral">error</mat-icon>
                }
                @if (
                  product.scoreClass &&
                  product.scoreClass.toLowerCase() === 'negative'
                ) {
                  <mat-icon class="negative">remove_circle</mat-icon>
                }
              } @else if (header.Type === 'curr') {
                {{ product[header.DataField] | currency }}
              } @else {
                {{ product[header.DataField] }}
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</section>
